export default __webpack_public_path__ + "static/media/results-poster.2c5c5e48.jpg";